<template>
  <breadcrumb :links="{ '/': 'Home', '/radar': 'Radar', 'current': 'Temporali' }"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div id="content_container">
      <div id="sidebar" v-if="showSidebar">
        <h4 class="text-center mt-4">Temporali</h4>
        <div class="p-2">
          <p>Grazie all'aggiornamento tecnologico del radar di Fossalon è possibile stimare la presenza di temporali
            forti
            assieme alla loro possibile evoluzione.</p>
          <p>Se la mappa si presenta vuota significa che non è stato individuato nessun temporale.</p>
          <p>Questa visualizzazione è <strong>sperimentale</strong> e come tutte le previsioni potrebbe non essere
            accurata.</p>
        </div>
        <div class="map_legend">
          <Legend :legend="this.legend">
          </Legend>
        </div>
      </div>
      <button class="btn btn-light button" id="close_sidebar" v-on:click="showSidebar = false; showXButton = false"
        v-if="showXButton">
        <i class="bi bi-x-lg p-2"></i>
        <span class="text-color">Temporali</span>
      </button>
      <div id="map_container">
        <div v-if="!radarAvailable" class="no_radar alert alert-warning alert-dismissible" role="alert">
          <i class="bi bi-exclamation-triangle"></i> {{ radarNotAvailable() }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <button v-if="!this.showSidebar" id="show_sidebar" class="btn btn-light button"
          v-on:click="showSidebar = true; showXButton = true">
          <i class="bi bi-list p-2"></i>
          <span class="text-color">Legenda</span>
        </button>
        <div class="frame_controls">
          <div class="info">
            <a :class="'clock' + (radar_time ? ' clock_on' : '')" v-on:click="chooseTime()"></a>
            <div class="label" v-if="data.length > 0">
              <span class='time'>{{ convertOnlyTime(data[0].dt).substring(0, 5) }}</span><span class='date'>{{
    convertOnlyDate(data[0].dt) }}</span>
            </div>
          </div>
          <div class="choose_time row justify-content-center" v-if="choose_time_dialog">
            <div class="col-md-2 col-xs-5">
              <input ref="toDateInput" class="form-control" type="date" v-model="inputDate" />
            </div>
            <div class="col-md-2 col-xs-5">
              <input ref="toTimeInput" class="form-control" type="time" v-model="inputTime" />
            </div>
            <div class="col-md-1 col-xs-1">
              <a class="btn btn-primary conditional_btn" v-on:click="setRadarTime(true)"
                v-if="inputDate && inputTime"><i class="bi bi-check-lg"></i></a>
              <a class="btn btn-secondary conditional_btn" v-on:click="setRadarTime(false)"><i
                  class="bi bi-x-lg"></i></a>
            </div>
          </div>
          <div class="fc_bgd"></div>
        </div>
        <Map class="map" :style="showBands ? '' : 'top: 0; right: 0;'" :data="imageLayers" :current="current"
          :collapsedLegend="true" @view_changed="adapt2View">
        </Map>
      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import Map from '@/components/Map/BaseFvgMap'
import Legend from '@/components/Legend'
import MonitorApi from '@/services/MonitorApi';
import Labels from '@/utils/labels';
import Breadcrumb from '@/components/Breadcrumb'
import AppFooterMini from '@/app-footer-mini.vue'
import { imageLayers, polygonLayers } from '@/components/Map/MapMarkers';
import { ref } from 'vue';

export default {
  components: { Map, Legend, Breadcrumb, AppFooterMini },
  mixins: [Labels],
  data: function () {
    return {
      showSidebar: true,
      legend: {},
      radarAvailable: true,
      data: [],
      imageLayers: [],
      current: 0,
      choose_time_dialog: false,
      inputDate: undefined,
      inputTime: undefined,
      radar_time: undefined
    }
  },
  setup() {
    const toDateInput = ref(null);
    const toTimeInput = ref(null);

    return {
      toDateInput,
      toTimeInput,
    };
  },
  methods: {
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar
    },
    featureStyle() {
      return {
        color: "#FF0000",
        fillColor: "#FFFFFF",
        fillOpacity: 0.0,
        weight: 2
      }
    },
    loadData: async function () {
      const max_time = 129600000; // 36 h
      let to = new Date;
      if (this.radar_time) {
        to = this.radar_time;
      }
      const from = new Date(to - max_time);
      let products = await MonitorApi.getRadarProducts(1, 'SSI', from, to, 1);
      const image = products[0];
      if (image == undefined) return;
      const e = image.details.extent;
      const extents = [];
      this.data = [{
        title: "SSI",
        type: 'image',
        dt: image.dt,
        url: 'https://monitor.protezionecivile.fvg.it/api/products/' + image.id,
        bounds: [[e[1], e[0]], [e[3], e[2]]]
      }];
      extents.push({
        bounds: [[e[0], e[1]], [e[2], e[3]]]
      });
      const pl = image.details.legend;
      this.legend = {
        type: 'ramp',
        title: "Intensità stimata",
        num_colors: 100,
        labels: [],
        stops: []
      };
      const length = pl.colormap.entries.length;
      for (let j = 0; j < length; j++) {
        const e = pl.colormap.entries[j];
        this.legend.labels.push(e.label);
        this.legend.stops.push({ color: e.color, value: j / (length - 1) });
      }
      products = await MonitorApi.getRadarProducts(1, 'HRT', from, to, 1);
      const product = products[0]
      if (product && product.dt >= image.dt) {
        const geoJson = await MonitorApi.getRadarProduct(product.id);
        geoJson.title = "HRT";
        this.imageLayers = imageLayers(this.data, extents).concat(polygonLayers(geoJson));
      } else {
        this.imageLayers = imageLayers(this.data, extents);
      }
    },
    chooseTime() {
      if (this.radar_time == undefined) {
        this.choose_time_dialog = true;
      } else {
        this.radar_time = undefined;
        this.loadData();
      }
    },
    setRadarTime(set_time) {
      if (set_time) {
        const toDate = this.toDateInput.valueAsDate;
        const toTime = this.toTimeInput.valueAsDate;
        toDate.setHours(toTime.getUTCHours());
        toDate.setMinutes(toTime.getMinutes());
        this.radar_time = toDate;
        this.loadData();
      }
      this.choose_time_dialog = false;
    }
  },
  mounted: async function () {
    this.showSidebar = false;
    await this.loadData();
    this.radarAvailable = (this.data.length > 0);
  }

}
</script>

<style lang="scss" scoped>
.text-color {
  padding: 10px;
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  color: #0067b1;
}

.button {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 50px;
  height: auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

#close_sidebar {
  position: absolute;
  left: 200px;
  z-index: 1011;
  background-color: #fff;
  opacity: 0.8;
  font-variant: small-caps;
  font-weight: bold;
}

#content_container {
  position: relative;
  height: 100%;
}

#map_container {
  position: relative;
  height: 100%;

  .map {
    position: absolute;
    width: 100%;
    bottom: 0;
  }

  .red_warning {
    position: absolute;
    top: 0;
    width: 100%;
    height: 30px;
    font-weight: bold;
    text-align: center;
    color: #FFF;
    background-color: #F00;
    z-index: 1;
  }
}

#sidebar {
  z-index: 1015;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  background-color: #fff;
  opacity: 0.8;
  overflow: auto;

  h4 {
    text-align: right;
    padding: 5px;
  }

  p {
    font-size: 14px;
    padding: 0 5px;
  }
}

#show_sidebar {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2000;
  font-variant: small-caps;
  font-weight: bold;
}

.map_legend {
  padding-top: 10px;
  height: 350px;
  font-size: 14px;
}

.no_radar {
  position: absolute;
  top: 160px;
  z-index: 2000;
  left: 20px;
  right: 50px;
}

.frame_controls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  .fc_bgd {
    background-color: #fff;
    opacity: 0.5;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .info {
    position: relative;
    z-index: 2010;
    margin: 0 auto;
    color: #0067b1;
    font-size: 20px;
    font-weight: bold;

    .clock {
      display: block;
      float: left;
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background-image: url(../assets/clock.png);
      background-position-x: 0;
      margin-top: 8px;
    }

    .clock_on {
      background-position-x: 41px;
    }

    .label {
      span.time {
        display: block;
        text-align: center;
      }

      span.date {
        display: block;
        text-align: center;
        font-size: 0.6em;
      }
    }
  }

  .choose_time {
    position: relative;
    z-index: 2010;
    width: 100%;
    padding: 10px;
  }

  @media (max-width: 768px) {
    .conditional_btn {
      display: block;
      margin: 0 auto;
      width: 50%;
      margin-top: 10px;
    }

    .choose_time {
      position: relative;
      z-index: 2010;
      width: 75%;
      padding: 10px;
    }
  }
}
</style>